export const text = {
  title: 'MANAGE SLOTS',
  timeSlot: 'Time Slot',
  timeInterval: 'Time Interval',
  selectTime:"Select time interval",
  noSlotsAvailable:"No Slots Available"
};
